import React from "react";
import "./deals.css";
import Plans from "./Plans";

function Deals() {
  return (
    <div className="dealsContainer">
      <h1 className="dealsHeader">Get your best deals</h1>
      <Plans />
    </div>
  );
}

export default Deals;
